import { render } from "./ContractHistoryBlockComponent.vue?vue&type=template&id=83d5b4e8&scoped=true"
import script from "./ContractHistoryBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractHistoryBlockComponent.vue?vue&type=script&lang=js"

import "./ContractHistoryBlockComponent.vue?vue&type=style&index=0&id=83d5b4e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d5b4e8"]])

export default __exports__